import { MapUiTheme } from '../../common';

export const checkboxTheme = {
  defaultStyles: {
    padding: '10px',
    display: 'block',
    position: 'relative',
    paddingLeft: (theme: MapUiTheme) => theme.spacing[11],
    paddingTop: (theme: MapUiTheme) => theme.spacing[2],
    paddingRight: (theme: MapUiTheme) => theme.spacing[4],
    cursor: 'pointer',
    fontSize: (theme: MapUiTheme) => theme.fontSize.base,
    marginRight: '10px',
    border: 'none',

    '& .__mapui_checkboxInput': {
      position: 'absolute',
      zIndex: (theme: MapUiTheme) => theme.zIndices.hide,
      opacity: '0',

      '&:checked': {
        '& ~ .__mapui_checkboxControl': {
          backgroundColor: (theme: MapUiTheme) => theme.colors.interaction200,
          borderColor: (theme: MapUiTheme) => theme.colors.interaction200,
        },

        '& ~ .__mapui_checkboxControl:after': {
          display: 'block',
        },
      },

      '&:disabled': {
        '& ~ .__mapui_checkboxControl': {
          backgroundColor: (theme: MapUiTheme) => theme.colors.neutral100,
          borderColor: (theme: MapUiTheme) => theme.colors.neutral500,
        },

        '& ~ .__mapui_checkboxControl:after': {
          borderColor: (theme: MapUiTheme) => theme.colors.neutral300,
        },
      },
    },

    '& .__mapui_checkboxControl': {
      position: 'absolute',
      top: '10px',
      left: '10px',
      height: '24px',
      width: '24px',
      backgroundColor: (theme: MapUiTheme) => theme.colors.white,
      border: (theme: MapUiTheme) => '1px solid ' + theme.colors.neutral500,
      borderRadius: '4px',
    },

    '& .__mapui_checkboxControl::after': {
      boxSizing: 'unset',
      content: "''",
      position: 'absolute',
      display: 'none',
      left: '8px',
      top: '3px',
      width: '5px',
      height: '12px',
      border: 'solid white',
      borderWidth: '0 2px 2px 0',
      transform: 'rotate(45deg)',
    },

    '&:hover .__mapui_checkboxInput:not([disabled]):checked ~ .__mapui_checkboxControl, .__mapui_checkboxInput:checked:focus ~ .__mapui_checkboxControl':
      {
        backgroundColor: (theme: MapUiTheme) => theme.colors.interaction200,
        borderColor: (theme: MapUiTheme) => theme.colors.interaction200,
      },
  },
  hasBorder: {
    border: (theme: MapUiTheme) => '1px solid ' + theme.colors.neutral500,
    borderRadius: '8px',
  },
};
